import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';

import { reportsApi } from '../api/reports-api';
import type { DayRange } from '../schemas/report-range';

import { reportKeys } from './report-keys';

export const TOP_CUSTOMERS_LIMIT = 20;

export function customersReportQueryOptions(storeId: string, { from, to }: DayRange) {
  return queryOptions({
    queryKey: reportKeys.customers(storeId, { from, to }, TOP_CUSTOMERS_LIMIT),
    queryFn: () => reportsApi.customers(storeId, { from, to }, TOP_CUSTOMERS_LIMIT),
    placeholderData: keepPreviousData,
  });
}

export function useCustomersReport(storeId: string, range: DayRange) {
  return useQuery(customersReportQueryOptions(storeId, range));
}
